import { ref } from 'vue'

type TBreakpoint = '2xl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs'

const queries: Record<TBreakpoint, string> = {
  '2xl': '(min-width: 1536px)',
  xl: '(min-width: 1280px)',
  lg: '(min-width: 1024px)',
  md: '(min-width: 768px)',
  sm: '(min-width: 640px)',
  xs: '(max-width: 639px)'
}

// reactive, shared across the app
const breakpointState: Record<TBreakpoint, ReturnType<typeof ref<boolean>>> = {
  '2xl': ref(false),
  xl: ref(false),
  lg: ref(false),
  md: ref(false),
  sm: ref(false),
  xs: ref(false)
}

const mediaQueryLists: Partial<Record<TBreakpoint, MediaQueryList>> = {}
let initialized = false

function initBreakpoints() {
  if (initialized) return
  if (typeof window === 'undefined') return
  initialized = true

  for (const bp of Object.keys(queries) as TBreakpoint[]) {
    const query = queries[bp]
    const mql = window.matchMedia(query)
    mediaQueryLists[bp] = mql

    const update = () => {
      breakpointState[bp].value = mql.matches
    }

    // initialize
    update()

    // add one listener for each breakpoint
    mql.addEventListener('change', update)
  }
}

export function useDetectBreakpoint(breakpoint: TBreakpoint): boolean {
  if (!initialized) {
    initBreakpoints()
  }

  return breakpointState[breakpoint]?.value ?? false
}
